import { LOAD, load } from 'model/internalAccount';
import { selectorCount } from 'selectors/internalAccount';
import LoanNumberMask from '../../Accounts/Internal/config/LoanNumberMask';
import ExpandedRow from './ExpandedRow';

export { default as ActionsRenderer } from './ActionsRenderer';
export const defaultOrderBy = 'id';

const MaskRenderer = (value, item, displayedAsContext, { deletedOnly }) => (
  <LoanNumberMask
    deletedOnly={deletedOnly}
    icon={displayedAsContext}
    item={item}
  />
);

export const columnMeta = [
  {
    xs: 2,
    id: 'accountNameDerived',
    label: 'Name',
  },
  {
    xs: 2,
    id: 'descriptionDerived',
    label: 'Description',
  },
  {
    xs: 2,
    id: 'accountNbrMask',
    label: 'Loan #',
    renderer: MaskRenderer,
  },
  {
    xs: 2,
    id: 'ddaStatus',
    label: 'Status',
  },
  {
    xs: 2,
    isDate: true,
    id: 'updatedAt',
    label: 'Updated At',
  },
];
export const TablePaginationProps = {
  action: load,
  actionType: LOAD,
  hasFspId: true,
  selectorCount,
};
export const TableProps = { stickyHeader: true };

export const detailsRender = (item) => <ExpandedRow item={item} />;
